import React from 'react';
import { MuiThemeProvider } from '@material-ui/core/styles'
import "react-table/react-table.css";
import Header from './Header'
import Table from './Table';
import { getCostCenters } from '../utils/PaymentRequestApiUtils';
import { Snackbar, LinearProgress, Dialog, DialogContent } from '@material-ui/core';

const COLUMNS = [
  {
    Header: "Cost Center Name",
    key: "LOCALNAME",
  },
  {
    Header: "Cost Center Code",
    key: "ZOLOCODE",
  },
];

class ViewCostCenter extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      snackOpen: false,
      snackMessage: '',
      inProgress: false,
      data: [],
    }
  }

  componentDidMount(props) {
    this.handleFetchData();
  }

  handleFetchData(){
    this.setState({ inProgress: true },() => {
      getCostCenters().then(response => {
        if (response) {
          console.log(response)
          if (response.status === 'success') {
            let data = response.data.cost_centers;
            this.setState({ data, inProgress: false })
          }
          else {
            this.setState({ snackMessage: response.message, snackOpen: true, inProgress: false })
          }
        }
      })
    })
  }

  handleCloseSnack() {
    this.setState({ snackOpen: false })
  }


  render() {
    return (
      < MuiThemeProvider>
        <Header/>
        <Table columns={COLUMNS} data={this.state.data} />
        <Dialog
          open={this.state.inProgress}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            Loading...
            <br/><br/>
            <LinearProgress />
          </DialogContent>
        </Dialog>
        <Snackbar
          open={this.state.snackOpen}
          message={this.state.snackMessage}
          autoHideDuration={2500}
          onClose={this.handleCloseSnack.bind(this)}
        />
      </MuiThemeProvider>
    )
  }
}
export default ViewCostCenter


// WEBPACK FOOTER //
// ./src/components/ViewCostCenter.js